import { notifications } from '@mantine/notifications';
import { IconAlertTriangleFilled, IconCircleCheckFilled, IconCircleXFilled, IconInfoCircleFilled } from '@tabler/icons-react';
import classes from './Toast.module.css';

type ToastOptions = {
  title: string;
  message: string;
  onClose?: () => void;
};

const DEFAULTS = {
  position: 'bottom-right' as const,
  withCloseButton: true,
  styles: { icon: { backgroundColor: 'transparent' }}
};

const DRAIN_MS = 8000;

const drain = ( bg: string ) => ({
  classNames: { root: classes.drain },
  style: { '--toast-bg': bg, '--toast-duration': `${DRAIN_MS}ms` } as React.CSSProperties
});

export const toast = {
  success({ title, message, onClose }: ToastOptions ) {
    notifications.show({ ...DEFAULTS, autoClose: DRAIN_MS, color: 'primary', icon: <IconCircleCheckFilled size={24} color="var(--mantine-primary-color-filled)" />, title, message, onClose, ...drain( 'var(--mantine-primary-color-light)' ) });
  },
  error({ title, message, onClose }: ToastOptions ) {
    notifications.show({ ...DEFAULTS, autoClose: false, color: 'red', icon: <IconCircleXFilled size={24} color="var(--mantine-color-red-filled)" />, title, message, onClose });
  },
  warning({ title, message, onClose }: ToastOptions ) {
    notifications.show({ ...DEFAULTS, autoClose: DRAIN_MS, color: 'yellow', icon: <IconAlertTriangleFilled size={24} color="var(--mantine-color-yellow-filled)" />, title, message, onClose, ...drain( 'var(--mantine-color-yellow-light)' ) });
  },
  info({ title, message, onClose }: ToastOptions ) {
    notifications.show({ ...DEFAULTS, autoClose: DRAIN_MS, color: 'blue', icon: <IconInfoCircleFilled size={24} color="var(--mantine-color-blue-filled)" />, title, message, onClose, ...drain( 'var(--mantine-color-blue-light)' ) });
  }
};
